export default {
  ADMIN: {
    label: 'Is Admin?',
    name: 'admin',
    id: 'admin',
  },
  SUPPORT: {
    text: 'Is Support User?',
    name: 'support',
    id: 'support',
  },
  subscriber: {
    text: 'Is Subscriber?',
    name: 'subscriber',
    id: 'subscriber',
  },
};
